
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import NodeFormMixin from '../forms/NodeFormMixin';

@Component({
  name: 'OpportunitySummary',
})
export default class OpportunitySummary extends NodeFormMixin { }
